<template>
   <!-- ref="appRef" -->
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// export default { name: 'App' }
import drawMixin from '@/mixins/drawMixin.js'
export default{
    name: 'App',
    mixins: [drawMixin],
    setup() {
        return {}
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue